import { Button, ButtonProps, CloseButton } from "@chakra-ui/react";
import React, { useState } from "react";

export const AsyncButton: React.FC<
  {
    action: () => Promise<void>;
    buttonType?: "normal" | "close";
  } & Omit<ButtonProps, "isLoading" | "onClick">
> = ({ action, buttonType, ...props }) => {
  const [loading, setLoading] = useState(false);
  const Component = buttonType === "close" ? CloseButton : Button;
  return (
    <Component
      {...props}
      onClick={async () => {
        setLoading(true);
        try {
          await action();
        } finally {
          setLoading(false);
        }
      }}
      {...(buttonType !== "close" ? { isLoading: loading } : {})}
    />
  );
};
